import TeamMemberJoinFailModal from '@/components/modal/team-member-join-fail-modal';
import { useMutateAcceptTeamInvitation } from '@/hooks/mutation/useMutateAcceptInvitation';
import { type JoinWorkspaceDialogPorts } from '@heidi/workspace';
import { useRouter } from 'next/router';

const renderJoinFailed: JoinWorkspaceDialogPorts['renderJoinFailed'] = ({
  teamId,
  onReturn,
}) => <TeamMemberJoinFailModal teamId={teamId} onReturn={onReturn} />;

/**
 * The app half of `@heidi/workspace`'s `JoinWorkspaceDialog`. The accept hook
 * crosses whole, not as the door's `acceptTeamInvitation`: its analytics, the
 * workspace switch and the switched-workspace result are app reactions.
 */
export const useJoinWorkspaceDialogPorts = (): JoinWorkspaceDialogPorts => {
  const router = useRouter();

  return {
    useAcceptTeamInvitation: useMutateAcceptTeamInvitation,
    renderJoinFailed,
    onNavigate: (href) => {
      void router.push(href);
    },
  };
};
